import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BookingInquiries = ({ adminKey }) => {
  const [items, setItems] = useState(null);
  const [confirmId, setConfirmId] = useState(null);

  const load = () => {
    if (!adminKey) {
      setItems(null);
      return;
    }
    axios
      .get(`${API}/inquiries`, { headers: { "X-Admin-Key": adminKey } })
      .then((r) => setItems(r.data))
      .catch(() => setItems(null));
  };

  useEffect(load, [adminKey]);

  const remove = async (id) => {
    await axios
      .delete(`${API}/inquiries/${id}`, { headers: { "X-Admin-Key": adminKey } })
      .catch(() => {});
    setConfirmId(null);
    load();
  };

  if (!items) return null;

  return (
    <div className="mt-16 border-t border-blue-100/10 pt-10" data-testid="booking-inquiries">
      <div className="flex items-baseline justify-between mb-6">
        <h2 className="font-display text-2xl font-bold uppercase tracking-tight" data-testid="inquiries-heading">
          Booking requests
        </h2>
        <span className="font-meta text-[10px] tracking-[0.25em] text-blue-300/50">
          {items.length} TOTAL
        </span>
      </div>

      {items.length === 0 && (
        <p className="text-sm font-light text-blue-100/50" data-testid="inquiries-empty">
          No booking requests yet. Share your booking page: jeremiahwomack.com/book
        </p>
      )}

      {items.map((q) => (
        <div key={q.id} className="border border-blue-100/15 p-5 mb-4" data-testid={`inquiry-${q.id}`}>
          <div className="flex justify-between items-start gap-3">
            <div className="min-w-0">
              <p className="font-display font-bold uppercase tracking-tight text-base sm:text-lg">
                {q.org_name}
              </p>
              <p className="font-meta text-[10px] tracking-[0.15em] text-blue-300/60 mt-1 break-all">
                {q.organizer_name} — {q.email}
                {q.phone ? ` — ${q.phone}` : ""}
              </p>
            </div>
            {confirmId === q.id ? (
              <button
                onClick={() => remove(q.id)}
                className="shrink-0 font-meta text-[10px] tracking-[0.2em] border border-red-400/60 text-red-400 px-3 py-1.5"
                data-testid={`inquiry-confirm-delete-${q.id}`}
              >
                SURE?
              </button>
            ) : (
              <button
                onClick={() => setConfirmId(q.id)}
                className="shrink-0 font-meta text-[10px] tracking-[0.2em] border border-blue-100/20 px-3 py-1.5 hover:border-red-400/60 hover:text-red-400 transition-colors"
                data-testid={`inquiry-delete-${q.id}`}
              >
                DELETE
              </button>
            )}
          </div>
          <dl className="mt-4 space-y-1.5 text-sm font-light text-blue-100/70">
            {[
              ["DATE", q.event_date],
              ["FORMAT", q.format],
              ["LOCATION", q.location],
              ["AUDIENCE", q.audience],
              ["TOPIC", q.topic],
            ].map(([k, v]) =>
              v ? (
                <div key={k} className="flex gap-3">
                  <dt className="font-meta text-[9px] tracking-[0.25em] text-blue-300/50 w-20 sm:w-24 shrink-0 pt-0.5">
                    {k}
                  </dt>
                  <dd className="min-w-0">{v}</dd>
                </div>
              ) : null
            )}
          </dl>
          {q.details && (
            <p className="text-sm font-light text-blue-100/60 mt-3 border-t border-blue-100/10 pt-3">
              {q.details}
            </p>
          )}
          <p className="font-meta text-[9px] tracking-[0.2em] text-blue-200/30 mt-3">
            RECEIVED {new Date(q.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }).toUpperCase()}
          </p>
        </div>
      ))}
    </div>
  );
};
